module.exports = "/legacy/df2e68757350eface82f458b3c36804d.svg";